import { LayoutStateArgs } from './Layout.types'
import { progressPercentage } from '@app/common/src/utils/ProgressBar'
import { useMemo } from 'react'

export function useLayoutState({
  currStep = 0,
  totalSteps = 0,
  showBackButton,
  showProgressBar
}: LayoutStateArgs): {
  percentage: number
  showBackButtonOrProgressBar: boolean
} {
  const percentage = useMemo(
    () => progressPercentage({ currStep, totalSteps }),
    [currStep, totalSteps]
  )
  const showBackButtonOrProgressBar = Boolean(showBackButton || showProgressBar)

  return {
    percentage,
    showBackButtonOrProgressBar
  }
}
